import { render, staticRenderFns } from "./NoticesManage.vue?vue&type=template&id=fdae804a&scoped=true&"
import script from "./NoticesManage.vue?vue&type=script&lang=js&"
export * from "./NoticesManage.vue?vue&type=script&lang=js&"
import style0 from "./NoticesManage.vue?vue&type=style&index=0&id=fdae804a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdae804a",
  null
  
)

export default component.exports